var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from "lit";
import { customElement, PICBase, PIC, PICAction, isNotificationPriority } from "../Internals";
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import { query } from 'lit/decorators.js';
let PICNotificationCenter = class PICNotificationCenter extends PICBase {
    constructor() {
        super();
        this.isHidden_ = true;
        this.notCountArr = [0, 0, 0, 0];
        this.doneLabel_ = 'Only Done';
        this.isinput__ = false;
    }
    get isHidden() {
        if (this.modal) {
            return this.modal.isHidden;
        }
        return this.isHidden_;
    }
    set isHidden(isHidden) {
        this.isHidden_ = isHidden;
        if (this.modal) {
            this.modal.isHidden = isHidden;
        }
        this.requestUpdate();
    }
    static get styles() {
        const defaultStyle = css `
            .container{
                height: 100%;   
                width: 100%;
            }
            .controls{
                display: flex; 
                flex-direction: row;
            }
            .flexer{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                gap: 1%;
                min-height: 60px;
                width: 100%;
                border-bottom: 1px solid var(--pic-outline, black);
            }
            .holder{
                display: flex;
                flex-direction: row;
                /* Same surface as the modal body this is slotted into - the
                   columns are meant to sit flush on it, so the 1% gaps between
                   them read as spacing rather than as bars of another color. */
                background-color: var(--pic-backgroundColor, white);
            }
            .holder.space{
                text-overflow: clip;
                white-space: nowrap;
                justify-content: space-between;
            }
            .holder.col1{
                /*width: 29%;
                min-width: 200px;*/
            }
            .priorityinfo{
                min-width: 60px;
                width: 20%;
                display: flex;
            }
            .priority{
                width: 48px;
                height: 48px;
                margin-left: 10%;
                border-radius: 5px;
                align-self: center;
                justify-self: center;
                color: white;
                font-family: 'Montserrat';
                font-weight: bold;
                font-size: 40px;
                -webkit-user-select: none; /* Safari */        
                -moz-user-select: none; /* Firefox */
                -ms-user-select: none; /* IE10+/Edge */
                user-select: none; /* Standard */
                text-align: center;
            }
            .priority.small{
                min-width: 18px;
                width: unset;
                height: 20px;
                font-size: 15px;
                padding-left: 3px;
                padding-right: 3px;
                border-radius: 3px;
                margin-left: 3px;
                border: 1px solid
            }
            .priority.small.toggled{
                /* Filtered-out state: drop the status fill so only the
                   status-colored border is left, sitting on the footer
                   surface (--pic-backgroundColor, same as .modal-footer). */
                background-color: var(--pic-backgroundColor, white);
                color: var(--pic-onSurfaceHighColor, black);
            }
            .priority.high{
                background-color: var(--pic-statusErrorColor);
                border-color: var(--pic-statusErrorColor);
            }
            .priority.medium{
                background-color: var(--pic-statusWarningColor);
                border-color: var(--pic-statusWarningColor);
            }
            .priority.low{
                background-color: var(--pic-statusOkColor);
                border-color: var(--pic-statusOkColor);
            }
            .priority.info{
                background-color: var(--pic-statusInfoColor);
                border-color: var(--pic-statusInfoColor);
            }
            .titleinfo{
                width: 80%;
                display: flex;
                flex-direction: column;
            }
            .holder.col1 .pic-subtitle2{
                line-height: 20px;
            }
            .bold{
                font-weight: bold;
            }
            .holder.col2{
                width: 60%;
                /*width: 49%;
                min-width: fit-content;*/
                flex-direction: column;
            }
            .holder.col2 div{
                width: 100%;
            }
            .top{
                align-self: flex-start;
                flex-grow: 4;
            }
            .bot{
                align-self: flex-end;
            }
            .holder.col3{
                /*width: 19%;
                min-width: 133px;*/
                flex-direction: column;
                margin-right: 5px;
            }
            .holder.col3 div{
                width: 100%;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.toggleSeenAction = new PICAction();
        this.toggleDoneAction = new PICAction();
        this.notificationAction = new PICAction();
        this.notCountArr = PIC.getInstance.getNotificationPriorityCount();
        this.notifications = PIC.getInstance.getNotifications();
        PIC.getInstance.addNotificationConsumer(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        PIC.getInstance.removeNotificationConsumer(this);
    }
    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this.toggleSeenAction.type_ = 'internal';
        this.toggleSeenAction.eventFnc = ((e) => { this.updateFilter('seen', true); }).bind(this);
        this.toggleDoneAction.type_ = 'internal';
        this.toggleDoneAction.eventFnc = ((e) => { this.updateFilter('done', true); }).bind(this);
    }
    handleNotification(iNotification) {
        var _a;
        this.notCountArr = PIC.getInstance.getNotificationPriorityCount();
        this.notifications = PIC.getInstance.getFilteredNotifications(this.filterObj);
        this.requestUpdate();
        (_a = this.modal) === null || _a === void 0 ? void 0 : _a.requestUpdate();
    }
    updateFilter(key, val) {
        var _a;
        if (!this.filterObj) {
            this.filterObj = {};
        }
        if (typeof val == 'boolean' && key == 'done') {
            if (key in this.filterObj) {
                if (this.filterObj[key]) {
                    this.filterObj[key] = false;
                    this.doneLabel_ = 'show all';
                }
                else {
                    delete this.filterObj[key];
                    this.doneLabel_ = 'only done';
                }
            }
            else {
                this.filterObj[key] = true;
                this.doneLabel_ = 'only not done';
            }
        }
        ;
        if (typeof val == 'boolean' && key == 'seen')
            this.filterObj[key] = !this.filterObj[key];
        if (typeof val == 'string' && ['priority', 'channelId'].includes(key)) {
            if (key == 'channelId')
                this.filterObj[key] = val;
            else if (key == 'priority' && isNotificationPriority(val)) {
                if (!(key in this.filterObj)) {
                    this.filterObj[key] = [];
                }
                if (this.filterObj[key].includes(val)) {
                    this.filterObj[key].splice(this.filterObj[key].indexOf(val), 1);
                }
                else {
                    (_a = this.filterObj[key]) === null || _a === void 0 ? void 0 : _a.push(val);
                }
            }
        }
        if (typeof val == 'undefined' && key in this.filterObj && key !== 'done') {
            delete this.filterObj[key];
        }
        this.notifications = PIC.getInstance.getFilteredNotifications(this.filterObj);
        this.requestUpdate();
    }
    toggle() {
        this.isHidden = !this.isHidden;
    }
    render() {
        let pncRef = this;
        function renderControls() {
            //toggle seen disabled for now.
            //<pic-button .action=${pncRef.toggleSeenAction} type='button' etype='contained' density='high' width=${150} label=${'Hide seen'}></pic-button>
            return html `                        
                <div class="controls">
                    <pic-button .action=${pncRef.toggleDoneAction} type='button' etype='contained' density='high' width=${175} label=${pncRef.doneLabel_}></pic-button>
                    ${renderPriorityFilter('high', 0)}
                    ${renderPriorityFilter('medium', 1)}
                    ${renderPriorityFilter('low', 2)}
                    ${renderPriorityFilter('info', 3)}
                </div>
            `;
            function renderPriorityFilter(iPrio, index) {
                return html `<div class=${classMap(getPriorityClassMap())} @click=${() => { pncRef.updateFilter('priority', iPrio); }}>${pncRef.notCountArr[index]}</div>`;
                function getPriorityClassMap() {
                    var _a, _b, _c;
                    return {
                        small: true,
                        priority: true,
                        [iPrio]: true,
                        // if filterObj doesnt have a priority array, all notifications will be shown
                        toggled: !((_c = (_b = (_a = pncRef.filterObj) === null || _a === void 0 ? void 0 : _a.priority) === null || _b === void 0 ? void 0 : _b.includes(iPrio)) !== null && _c !== void 0 ? _c : true)
                    };
                }
            }
        }
        function renderNotification(iNot, iIdx) {
            var _a;
            return html `
                <div class="flexer">
                    <div class="holder col1">
                        <div class="priorityinfo">
                            <div class="priority ${iNot.priority}" @click=${(e) => { PIC.getInstance.removeNotification(iNot.category, iNot); }}>
                                N
                            </div>
                        </div>
                        <div class="titleinfo">
                            <div class="pic-subtitle2 bold">
                                ${iNot.title}
                            </div>
                            <div class="pic-subtitle2">
                                ${(_a = iNot.timestamp) === null || _a === void 0 ? void 0 : _a.toLocaleString('en-GB')}
                            </div>
                            <div class="holder space pic-subtitle2">
                                <div class="category">
                                    ${iNot.category}
                                </div>
                                <div class="seen">
                                    ${ /*iNot.seen?'Seen':'Not Seen'*/''}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="holder col2 pic-body2">
                        <div class="top">
                            ${iNot.message}
                        </div>
                        <div class="bot">
                            ${renderActions(iNot.actions)}
                        </div>
                    </div>
                    <div class="holder col3 pic-body2">
                        <div class="bold top">Assigned:</div>

                        <div class="bot holder space">
                            <div @click=${(e) => { iNot.done = true; PIC.getInstance.updateNotification(iNot.category, iNot); }}>Assign PICIT and Done</div>
                        </div>
                    </div>
                </div>
            `;
            function renderActions(iActionArr) {
                let res = [];
                iActionArr === null || iActionArr === void 0 ? void 0 : iActionArr.forEach(actType => {
                    res.push(html `<div @click=${(e) => { pncRef.notificationAction.actionOptions = actType; pncRef.notificationAction.triggerEvent(e); }}>${actType.event}</div>`);
                });
                return res;
            }
        }
        return html ` 
            <pic-modal .isNew=${true} .isHidden=${this.isHidden} .title_=${'Notification center ' + PIC.getInstance.getNotificationCount()}>
                <div
                    slot="slot-modal-body"
                    class="container">
                    ${repeat(this.notifications, (notific) => notific, (notific, index) => renderNotification(notific, index))}
                </div>
                <div slot="slot-modal-footer">
                    ${renderControls()}
                </div>
            </pic-modal>
        `;
    }
    ;
};
__decorate([
    query('pic-modal')
], PICNotificationCenter.prototype, "modal", void 0);
PICNotificationCenter = __decorate([
    customElement('pic-notificationcenter')
], PICNotificationCenter);
export { PICNotificationCenter };
//# sourceMappingURL=PICNotificationCenter.js.map